module.exports = __webpack_public_path__ + "img/webpush-contract-akcii.9534295f.svg";